<template>
  <div class="divider">
    <div class="text">
      {{ text }}
    </div>
  </div>
</template>

<script>
/**
 * This component represents common UI for displaying the status in the progress list
 */
export default {
  name: 'TextDivider',
  props: {
    text: String
  }
};
</script>

<style lang="sass" scoped>
.divider
  position: relative;
  width: 100%;
  border-bottom: 1px solid #E0E0E0;
.text
  position: absolute;
  display: inline-block;
  background: #fff;
  margin: 0 auto;
  width: 41px;
  left: 0;
  right: 0;
  top: -10px;
  text-align: center;
</style>
